module.exports = __webpack_public_path__ + "img/KNVB.1bee4b57.png";